import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DashboardShell } from '@/components/DashboardShell';
import { QxoCapitalDesk } from '@/components/qxo/QxoCapitalDesk';
import { QxoDatasetFocus, QxoDatasetTable } from '@/components/qxo/QxoDatasetFocus';
import { QxoFilingsDesk } from '@/components/qxo/QxoFilingsDesk';
import { QxoRoofingMarketDashboard } from '@/components/qxo/QxoRoofingMarketDashboard';
import { QxoStreetPanel } from '@/components/qxo/QxoStreetPanel';
import { QxoUniverseDesk } from '@/components/qxo/QxoUniverseDesk';
import { datasetBoard } from '@/components/qxo/qxoDatasetCatalog';
import { QxoFocusContext } from '@/components/qxo/qxoFocus';
import { useStreetSnapshot } from '@/components/qxo/qxoStreet';

const BOARDS = [
  { id: 'market', label: 'Roofing market' },
  { id: 'universe', label: 'Industry universe' },
  { id: 'filings', label: 'Filings: Beacon platform' },
  { id: 'capital', label: 'Capital structure' },
  { id: 'street', label: 'Street & ownership' },
] as const;

export function QxoDeskPage() {
  const street = useStreetSnapshot('QXO');
  const spot = street.status === 'ready' ? street.data.quote.price : null;
  const snapshot = street.status === 'ready' ? street.data : null;
  const [params, setParams] = useSearchParams();
  const focusId = params.get('dataset');

  useEffect(() => {
    if (focusId) window.scrollTo(0, 0);
  }, [focusId]);

  const open = (id: string) => {
    setParams({ dataset: id });
  };
  const close = () => {
    setParams({});
  };

  const board = focusId ? datasetBoard(focusId) : null;

  return (
    <QxoFocusContext.Provider value={{ focusId, open }}>
      <DashboardShell activeTab="qxo">
        <main className="mx-auto max-w-[1500px] px-6 py-10">
          {focusId ? (
            <QxoDatasetFocus id={focusId} snapshot={snapshot} onClose={close} />
          ) : (
            <nav className="mb-4 flex flex-wrap gap-2 text-[12px]">
              {BOARDS.map((b) => (
                <a
                  key={b.id}
                  href={`#${b.id}`}
                  className="rounded-md border border-sky-900/60 bg-[#0d3358] px-3 py-1 text-sky-200 hover:bg-[#0a2744] hover:text-white"
                >
                  {b.label}
                </a>
              ))}
            </nav>
          )}
          <div className="space-y-8">
            {board === null || board === 'market' ? (
              <div id="market">
                <QxoRoofingMarketDashboard />
              </div>
            ) : null}
            {board === null || board === 'universe' ? <QxoUniverseDesk /> : null}
            {board === null || board === 'filings' ? <QxoFilingsDesk /> : null}
            {board === null || board === 'capital' ? <QxoCapitalDesk spotPrice={spot} /> : null}
            {board === null || board === 'street' ? <QxoStreetPanel state={street} /> : null}
          </div>
          {focusId ? <QxoDatasetTable id={focusId} snapshot={snapshot} /> : null}
        </main>
      </DashboardShell>
    </QxoFocusContext.Provider>
  );
}
